import $ from 'jquery';
import Component from './index';

class Pjax extends Component {
    mount() {
        $(window).on(`popstate.${this.id}`, () => {
            this.loadUrl(window.location.href, false);
        });
    }

    unmount() {
        $(window).off(`popstate.${this.id}`);
    }

    loadUrl(url, pushState = true) {
        this.trigger('loading', url);

        this.fetchPage(url, $doc => {
            // Update document title.
            const title = $doc.find('title').text();
            document.title = title;

            // Update the pjax container HTML.
            this.$el.html($doc.find(this.selector).html());

            this.trigger('loaded', [$doc, url]);

            // Add browser history entry for the new page.
            if (pushState) {
                window.history.pushState({}, title, url);
            }
        });
    }

    fetchPage(url, cb) {
        $.get(url)
            .done(response => {
                const $doc = $('<div>').append($.parseHTML(response));
                cb($doc);
            })
            .fail(() => {
                console.error('Could not update page', url);
                window.location.assign(url);
            });
    }
}

export default Pjax;
